export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_14-a505875a5d2b0034d4b19309181adfd3.jpg";